<template>
  <nav class="bg-hahn-100 p-4 text-white flex justify-between h-15 relative">
    <svg class="left-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 140 55" style="fill:white;">
      <path class="svg-white" d="M43.62,26.64h13.49l2,6.12h8.22L55.54,1.01l-10.37.05-11.58,31.7h7.94s2.09-6.12,2.09-6.12ZM49.88,7.69h1.22l4.04,12.65h-9.58l4.32-12.65h.01ZM138.99,1.01v22.37c0,5.19-4.22,9.39-9.4,9.39h-1.44c-5.2,0-9.4-4.21-9.4-9.39v-2.43h0v-10.76c0-1.38-1.12-2.5-2.5-2.51h0c-1.38,0-2.49,1.11-2.49,2.49v22.6h-7.63V10.4c0-5.19,4.2-9.4,9.39-9.4h1.44c5.2,0,9.41,4.2,9.41,9.39h0v2.44h0v10.76c-.07,1.38,1,2.55,2.38,2.62s2.55-1,2.62-2.38V1.01h7.63-.01ZM92.23,32.76v-12.93h-12.41v12.93h-7.63V1.01h7.63v12.48h12.41V1.01h7.63v31.75h-7.63ZM21.04,1.01h7.63v31.75h-7.63v-12.93h-12.41v12.93H1V1.01h7.63v12.48h12.41V1.01ZM5.57,42.55c-.02-.07-.07-.13-.13-.17-.12-.07-.27-.07-.4,0-.06.04-.11.1-.12.17l-3.9,11.01s-.02.06-.02.09c0,.05,0,.1.05.13.03.04.08.07.12.09.11.05.24.04.35-.02.06-.03.11-.09.12-.16l.9-2.58h5.34l.91,2.58c.02.07.06.12.12.16.05.03.11.05.17.05s.12,0,.17-.04c.05-.02.1-.06.13-.1.03-.03.05-.08.05-.13,0-.03,0-.05-.02-.08l-3.86-11.01h.01ZM2.75,50.56l2.49-7.04,2.45,7.04H2.75ZM18.31,42.69v8.08c.03.66-.13,1.32-.47,1.89-.3.47-.74.83-1.26,1.03-.57.22-1.17.33-1.78.32-.61,0-1.21-.1-1.77-.32-.51-.21-.95-.56-1.25-1.03-.34-.57-.5-1.22-.47-1.89v-8.08c0-.08.03-.16.1-.2.14-.08.31-.08.45,0,.07.04.1.12.1.2v8.08c-.06.75.21,1.49.75,2.02.59.47,1.34.7,2.09.65.76.04,1.5-.19,2.1-.65.54-.52.82-1.27.76-2.02v-8.08c0-.08.03-.16.1-.2.14-.08.31-.08.45,0,.07.04.1.12.1.2M27.55,42.5s.08.12.08.19-.03.14-.07.2c-.06.07-.16.1-.25.09h-3.17v10.64c0,.08-.03.16-.1.21-.13.09-.31.09-.45,0-.07-.05-.11-.13-.1-.21v-10.63h-3.18c-.09,0-.17-.03-.23-.09-.11-.09-.12-.26-.03-.37,0,0,.02-.02.03-.03.06-.06.15-.09.23-.09h7.01c.09,0,.17.02.24.08M34.11,42.74c-.57-.22-1.17-.33-1.78-.32-.61,0-1.21.1-1.77.32-.51.21-.95.57-1.25,1.03-.34.57-.5,1.23-.47,1.89v5.11c-.03.66.13,1.32.47,1.89.3.46.74.82,1.25,1.03.56.22,1.17.33,1.77.32.61,0,1.21-.1,1.78-.32.52-.2.96-.56,1.26-1.03.34-.57.5-1.22.47-1.89v-5.11c.03-.66-.13-1.32-.47-1.89-.3-.47-.74-.83-1.26-1.03M35.19,50.77c.06.75-.22,1.49-.76,2.02-.6.46-1.34.7-2.1.65-.75.05-1.5-.19-2.09-.65-.54-.53-.81-1.27-.75-2.02v-5.11c-.06-.75.21-1.49.75-2.02.59-.47,1.34-.7,2.09-.65.76-.04,1.5.19,2.1.65.54.52.82,1.27.76,2.02v5.11ZM47.41,42.69v10.93c0,.08-.03.16-.1.21-.13.09-.31.09-.45,0-.07-.05-.11-.13-.1-.21v-9.82l-3.38,5.72c-.04.08-.1.16-.17.23-.05.04-.11.07-.17.07s-.12-.03-.16-.07c-.07-.06-.13-.14-.18-.23l-3.36-5.72v9.82c0,.08-.03.16-.1.21-.13.09-.31.09-.45,0-.07-.05-.11-.13-.1-.21v-10.94c0-.08.03-.17.1-.21s.15-.06.22-.05c.09,0,.17.04.23.11.07.08.14.16.2.24.05.07.09.14.12.21l3.47,6,3.49-6s.08-.12.13-.21c.06-.09.12-.17.2-.24.06-.06.14-.1.22-.11.08,0,.16.02.23.05.07.05.1.13.09.21M53.92,42.55c-.02-.07-.07-.13-.13-.17-.12-.07-.27-.07-.4,0-.06.04-.11.1-.12.17l-3.89,11.01s-.02.06-.02.09c0,.05,0,.1.04.13.03.04.08.07.12.09.11.05.24.04.35-.02.06-.03.11-.09.12-.16l.9-2.58h5.34l.91,2.58c.02.07.06.12.12.16.05.03.11.05.17.05s.12,0,.17-.04c.05-.02.1-.06.13-.1.03-.03.05-.08.05-.13,0-.03,0-.05-.02-.08l-3.86-11.02v.02h.01ZM51.09,50.56l2.49-7.04,2.45,7.04h-4.95ZM65.08,42.5s.08.12.08.19-.03.14-.07.2c-.06.07-.16.1-.25.09h-3.18v10.64c0,.08-.03.16-.1.21-.13.09-.31.09-.45,0-.07-.05-.11-.13-.1-.21v-10.63h-3.18c-.09,0-.17-.03-.23-.09-.11-.09-.12-.26-.03-.37l.03-.03c.06-.06.15-.09.23-.09h7.01c.09,0,.17.02.24.08M67.53,42.69v10.93c0,.08-.03.16-.1.21-.13.09-.31.09-.45,0-.07-.05-.11-.13-.1-.21v-10.94c0-.08.03-.16.1-.2.14-.08.31-.08.45,0,.07.04.1.12.1.2M75.65,42.74c-.57-.22-1.17-.33-1.78-.32-.61,0-1.21.1-1.77.32-.51.21-.95.57-1.25,1.03-.34.57-.5,1.23-.46,1.89v5.11c-.03.66.13,1.32.46,1.89.3.46.74.82,1.25,1.03.56.22,1.17.33,1.77.32.61,0,1.21-.1,1.78-.32.52-.2.96-.56,1.26-1.03.34-.57.5-1.22.46-1.89v-5.11c.03-.66-.13-1.32-.46-1.89-.3-.47-.74-.83-1.26-1.03M76.73,50.76c.06.75-.22,1.49-.76,2.02-.6.46-1.34.7-2.1.65-.75.05-1.5-.19-2.09-.65-.54-.53-.81-1.27-.75-2.02v-5.11c-.06-.75.21-1.49.75-2.02.59-.47,1.34-.7,2.09-.65.76-.04,1.5.19,2.1.65.54.52.82,1.27.76,2.02v5.11ZM87.24,42.69v10.93c0,.08-.03.16-.1.21s-.14.07-.22.07c-.13,0-.24-.08-.3-.2-.08-.13-.15-.25-.21-.36l-5.52-9.54v9.82c0,.08-.03.16-.1.21-.13.09-.31.09-.45,0-.07-.05-.11-.13-.1-.21v-10.94c0-.08.03-.17.1-.21s.15-.06.22-.05c.09,0,.17.04.23.11.07.08.14.16.2.24.05.07.09.14.12.21l5.48,9.52v-9.82c0-.08.03-.16.1-.2.14-.08.31-.08.45,0,.07.04.1.12.1.2M94.32,45.66v5.11c-.06.75.21,1.49.75,2.02.59.47,1.34.7,2.09.65.76.04,1.5-.19,2.1-.65.54-.52.82-1.27.76-2.02v-2.33h-2.85c-.08,0-.17-.03-.22-.09-.11-.11-.11-.28,0-.39.06-.06.14-.09.22-.09h3.18c.08,0,.17.03.22.09s.08.13.08.21v2.59c.03.66-.13,1.32-.46,1.89-.3.47-.74.83-1.26,1.03-.57.22-1.17.33-1.78.32-.61,0-1.21-.1-1.77-.32-.51-.21-.95-.56-1.25-1.03-.34-.57-.5-1.22-.46-1.89v-5.11c-.03-.66.13-1.32.46-1.89.3-.46.74-.82,1.25-1.03,1.18-.44,2.48-.43,3.66.02.48.2.89.52,1.2.93.28.38.42.84.42,1.31,0,.09-.03.18-.1.24-.06.05-.14.08-.22.08s-.15-.02-.21-.07-.1-.13-.11-.21c-.05-.42-.22-.83-.48-1.16-.26-.31-.6-.54-.98-.68-.45-.15-.92-.23-1.4-.22-.75-.05-1.5.19-2.09.65-.54.53-.81,1.27-.75,2.02M109.91,47.06c.29-.5.43-1.06.4-1.63.04-.64-.14-1.27-.51-1.8-.35-.44-.82-.76-1.35-.93-.59-.19-1.21-.28-1.82-.27h-2.98c-.08,0-.17.04-.23.09-.06.04-.09.11-.09.18v10.93c0,.08.03.16.1.21.13.09.31.09.45,0,.07-.05.1-.13.1-.21v-5.18h2.65l2.86,4.9c.06.1.13.23.21.36.06.12.17.19.3.2.06,0,.11,0,.16-.04.05-.02.09-.06.12-.1.03-.04.05-.09.04-.14v-.08s-.02-.07-.04-.09l-2.95-5.04c.53-.05,1.04-.19,1.52-.41.44-.2.82-.53,1.08-.94M106.62,47.87h-2.67v-4.88h2.67c.77-.03,1.53.16,2.19.57,1.03.91,1.14,2.48.23,3.51-.07.08-.15.16-.23.23-.66.41-1.42.61-2.19.57M117.58,42.74c-.57-.22-1.17-.33-1.78-.32-.61,0-1.21.1-1.77.32-.51.21-.95.57-1.25,1.03-.34.57-.5,1.23-.46,1.89v5.11c-.03.66.13,1.32.46,1.89.3.46.74.82,1.25,1.03.56.22,1.17.33,1.77.32.61,0,1.21-.1,1.78-.32.52-.2.96-.56,1.26-1.03.34-.57.5-1.22.46-1.89v-5.11c.03-.66-.13-1.32-.46-1.89-.3-.47-.74-.83-1.26-1.03M118.66,50.77c.06.75-.22,1.49-.76,2.02-.6.46-1.34.7-2.1.65-.75.05-1.5-.19-2.09-.65-.54-.53-.81-1.27-.75-2.02v-5.11c-.06-.75.21-1.49.75-2.02.59-.47,1.34-.7,2.09-.65.76-.04,1.5.19,2.1.65.54.52.82,1.27.76,2.02v5.11ZM129.09,42.69v8.08c.03.66-.13,1.32-.46,1.89-.3.47-.74.83-1.26,1.03-.57.22-1.17.33-1.78.32-.61,0-1.21-.1-1.77-.32-.51-.21-.95-.56-1.25-1.03-.34-.57-.5-1.22-.46-1.89v-8.08c0-.08.03-.16.1-.2.14-.08.31-.08.45,0,.07.04.1.12.1.2v8.08c-.06.75.21,1.49.75,2.02.59.47,1.34.7,2.09.65.76.04,1.5-.19,2.1-.65.54-.52.82-1.27.76-2.02v-8.08c0-.08.03-.16.1-.2.14-.08.31-.08.45,0,.07.04.1.12.1.2M137.27,42.74c-.57-.22-1.17-.33-1.78-.32h-3.17c-.08,0-.17.04-.23.09-.06.04-.09.11-.09.18v10.93c0,.08.03.16.1.21.13.09.31.09.45,0,.07-.05.1-.13.1-.21v-4.52h2.84c.61,0,1.21-.1,1.78-.32.52-.2.96-.57,1.26-1.04.34-.57.5-1.23.46-1.89v-.19c.03-.66-.13-1.32-.46-1.89-.3-.47-.74-.83-1.26-1.03M138.34,45.84c.06.76-.22,1.5-.76,2.03-.6.47-1.34.7-2.1.66h-2.85v-5.54h2.84c.76-.04,1.5.19,2.1.65.54.52.82,1.27.76,2.02v.19h.01Z"></path>
    </svg>
    <h1 class="w-full absolute text-center">
      VPN Gateway Manager
    </h1>
    <h1 class="w-full absolute text-center">
      <ProfileDropdown/>
      <button
          @click="isModalOpen=!isModalOpen"
          class="text-xl text-white hover:text-white-100 focus:outline-none absolute right-4 p-2 px-4 min-w-6 -my-13 h-11 group z-10 border-hahn-dark-100 rounded-lg"
          aria-label="Help"
      >
        ?
      </button>
    </h1>
  </nav>
  <div class="relative w-full xl:w-2/3 mx-auto pt-2 grid grid-cols-1">
    <input placeholder="Search" class="mx-2 xl:mx-0 border-0 h-10 p-2 bg-hahn-200" v-model="filter"/>
    <div class="h-10 w-10 absolute z-2 mt-2 bg-white/10 hover:bg-white/5 mr-2 xl:mr-0 right-0 p-2 fill-hahn-dark-50 cursor-pointer" @click="filter=''" v-if="filter !== ''">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
           viewBox="0 0 490 490" xml:space="preserve">
        <polygon points="456.851,0 245,212.564 33.149,0 0.708,32.337 212.669,245.004 0.708,457.678 33.149,490 245,277.443 456.851,490
          489.292,457.678 277.331,245.004 489.292,32.337 "/>
      </svg>
    </div>
    <div class="pt-2">
      <PeerListEntry v-for="(peer, n) in filteredPeers" :key="peer.device.id" :peer="peer" :class="{
      'mt-0': n === 0,
    }" :expand="filter !== ''"/>
    </div>
    <div
        v-if="isModalOpen"
        class="fixed inset-0 bg-gray-900/70 flex justify-center items-center z-50"
        @click="isModalOpen=!isModalOpen"
    >
      <div
          class="bg-hahn-100/50 p-6 shadow-lg max-w-lg w-full"
          @click.stop
      >
        <h2 class="text-xl font-bold mb-4">Remote Maintenance Instructions</h2>
        <div class="text-sm">
Welcome to the Remote Maintenance Portal.<br/><br/>

This portal allows you to download a device-specific OpenVPN configuration file, which includes a certificate that is valid for 24 hours only.<br/><br/>

Important Notes:<br/>
1. Only one device can be connected at a time for remote maintenance.<br/>
2. Attempting to connect to two different devices simultaneously will not work.<br/><br/>

Please ensure that you have the correct device and configuration before proceeding.
        </div>
        <button
            @click="isModalOpen=!isModalOpen"
            class="mt-4 bg-blue-600 text-white px-4 py-2 rounded-lg focus:outline-none hover:bg-blue-700"
        >
          Close
        </button>
      </div>
    </div>


  </div>

</template>

<script>
import ProfileDropdown from "@/components/ProfileDropdown.vue";
import PeerListEntry from "@/components/PeerListEntry.vue";
import {ref} from "vue";

export default {
  name: 'App',
  data() {
    return {
      peers: ref(null),
      authenticated: false,
      filter: ref(""),
      isModalOpen: false,
    }
  },
  components: {
    PeerListEntry,
    ProfileDropdown
  },
  created() {
    // Initialize Keycloak and handle the authentication
    this.fetchPeers()
    setInterval(() => {
      this.fetchPeers()
    }, 10000)
  },
  computed: {
    filteredPeers() {
      if (this.filter === undefined || this.filter === "") {
        return this.peers
      }

      let attributes = [];
      let text = "";

      this.filter.trim().split(" ").filter((arg) => {
        if (arg.startsWith("@")) {
          attributes.push(arg.replaceAll("@", ""));
        } else {
          text=` ${arg}`;
        }
      })
      text=text.trim().toLowerCase()
      return this.peers.filter((peer) => {
        if (attributes.indexOf("UP") > -1 && peer.wg_status.loss > 0) {
          return false
        }
        if (attributes.indexOf("DOWN") > -1 && peer.wg_status.loss < 100) {
          return false
        }
        if (text === "") {
          return true
        }
        if (peer.device?.name?.toLowerCase().includes(text)) {
          return true
        }
        if (peer.device?.comments?.toLowerCase().includes(text)) {
          return true
        }
        if (peer.wg_status?.allowed_ips?.toLowerCase().includes(text)) {
          return true
        }
        return !!peer.device?.id?.includes(text);
      })
    }
  },
  methods: {
    fetchPeers() {
      fetch('/api/peers', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$keycloak.token
        }
      })
      .then(response => {
        if (!response.ok) {
          // If the response is not OK, throw an error
          throw new Error('Network response was not ok');
        }
        return response.json(); // Parse the JSON from the response
      })
      .then(data => {
        // Store the fetched data
        this.peers = data;
      })
      .catch(error => {
        // If there's an error, store the error message
        this.error = error.message;
      });
    }
  }
}
</script>